<div
    class="flex flex-col flex-auto items-center sm:justify-center min-w-0 sm:p-8 md:py-16 md:px-16"
>
    <div class="flex w-full h-full rounded-2xl shadow-2xl overflow-hidden">
        <div
            class="flex items-center justify-center h-full p-16 lg:px-28 overflow-hidden border-r-2"
        >
            <ng-lottie [options]="options" class="scale-125" />
        </div>
        <div class="w-full py-8 px-4 sm:p-12 md:p-16">
            <div
                class="flex flex-col w-full h-full justify-center max-w-100 mx-auto sm:mx-0"
            >
                <!-- Title -->
                <div
                    class="text-4xl font-extrabold tracking-tight leading-tight text-secondary"
                    >Sign up</div
                >
                <div
                    class="flex text-secondary items-baseline mt-0.5 font-medium"
                >
                    <div>Already have an account?</div>
                    <a
                        class="ml-1 text-primary-500 hover:underline"
                        [routerLink]="[authConfig.getConfig().routes.signIn]"
                        >Sign in
                    </a>
                </div>

                <!-- Alert -->
                <zop-alert
                    class="mt-8 -mb-4"
                    *ngIf="showAlert"
                    [appearance]="'outline'"
                    [showIcon]="false"
                    [type]="alert.type"
                    [@shake]="alert.type === 'error'"
                >
                    {{ alert.message }}
                </zop-alert>

                <!-- Sign in form -->
                <form
                    class="mt-8"
                    [formGroup]="signUpForm"
                    #signUpNgForm="ngForm"
                    *ngIf="countries"
                >
                    <div class="flex flex-col">
                        <div class="flex flex-row mb-1">
                            <mat-label class="text-black font-medium"
                                >First Name</mat-label
                            >
                        </div>

                        <div class="flex flex-row">
                            <mat-form-field class="w-1/4">
                                <!-- <mat-label>Salutation</mat-label> -->
                                <mat-select
                                    class="w-full"
                                    [formControlName]="'salutation'"
                                    matPrefix
                                >
                                    <ng-container
                                        *ngFor="
                                            let salutation of salutationArray
                                        "
                                    >
                                        <mat-option [value]="salutation">
                                            {{ salutation | enumToDescription }}
                                        </mat-option>
                                    </ng-container>
                                </mat-select>
                            </mat-form-field>

                            <mat-form-field class="w-full ml-2">
                                <!-- <mat-label>First name</mat-label> -->
                                <input
                                    id="name"
                                    matInput
                                    [formControlName]="'firstName'"
                                />

                                <mat-error
                                    *ngIf="
                                        signUpForm
                                            .get('firstName')
                                            ?.hasError('required')
                                    "
                                >
                                    This field is required.
                                </mat-error>

                                <mat-error
                                    *ngIf="
                                        signUpForm
                                            .get('firstName')
                                            ?.hasError('maxlength')
                                    "
                                >
                                    This field must have at most 50 characters.
                                </mat-error>

                                <mat-error
                                    *ngIf="
                                        !signUpForm
                                            .get('firstName')
                                            ?.hasError('required') &&
                                        !signUpForm
                                            .get('firstName')
                                            ?.hasError('minlength') &&
                                        !signUpForm
                                            .get('firstName')
                                            ?.hasError('maxlength')
                                    "
                                >
                                    Invalid first name format.
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <mat-form-field class="fuse-mat-no-subscript w-full">
                        <mat-label>Last name</mat-label>
                        <input
                            id="name"
                            matInput
                            [formControlName]="'lastName'"
                        />

                        <mat-error
                            *ngIf="
                                signUpForm
                                    .get('lastName')
                                    ?.hasError('maxlength')
                            "
                        >
                            This field must have at most 50 characters.
                        </mat-error>

                        <mat-error
                            *ngIf="
                                !signUpForm
                                    .get('lastName')
                                    ?.hasError('minlength') &&
                                !signUpForm
                                    .get('lastName')
                                    ?.hasError('maxlength')
                            "
                        >
                            Invalid last name format.
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field class="w-full">
                        <mat-label>Email</mat-label>
                        <mat-icon
                            matPrefix
                            class="hidden sm:flex icon-size-5"
                            [svgIcon]="'heroicons_solid:mail'"
                        >
                        </mat-icon>
                        <input
                            matInput
                            formControlName="email"
                            [placeholder]="'Email address'"
                            [spellcheck]="false"
                        />

                        <mat-error
                            *ngIf="
                                signUpForm.get('email')?.hasError('required')
                            "
                        >
                            This field is required.
                        </mat-error>
                        <mat-error
                            *ngIf="
                                signUpForm.get('email')?.hasError('minlength')
                            "
                        >
                            This field must have at least 1 character.
                        </mat-error>
                        <mat-error
                            *ngIf="
                                signUpForm.get('email')?.hasError('maxlength')
                            "
                        >
                            This field must have at most 250 characters.
                        </mat-error>
                        <mat-error
                            *ngIf="
                                !signUpForm
                                    .get('email')
                                    ?.hasError('required') &&
                                !signUpForm
                                    .get('email')
                                    ?.hasError('minlength') &&
                                !signUpForm
                                    .get('email')
                                    ?.hasError('maxlength') &&
                                signUpForm
                                    .get('email')
                                    ?.hasError('emailValidator')
                            "
                        >
                            Invalid email format.
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field class="fuse-mat-no-subscript w-full">
                        <mat-label>Mobile Number</mat-label>
                        <input
                            matInput
                            formControlName="mobileNumber"
                            [placeholder]="'1234567890'"
                        />
                        <mat-select
                            class="mr-1.5"
                            formControlName="mobileNumberCountry"
                            matPrefix
                        >
                            <!-- <mat-select-filter [placeholder]="'Search Country'" [displayMember]="'name'"
                                [array]="countries" (filteredReturn)="filteredCountriesMobile =$event">
                            </mat-select-filter> -->
                            <mat-select-trigger>
                                <span class="flex items-center">
                                    <span
                                        class="hidden sm:flex w-6 h-4 mr-1 overflow-hidden"
                                        [style.background]="
                                            'url(\'/assets/images/countries/flags.png\') no-repeat 0 0'
                                        "
                                        [style.backgroundSize]="'24px 3876px'"
                                    ></span>
                                    <!-- [style.backgroundPosition]="
                                            getCountryByIso(
                                                signUpForm.get(
                                                    'mobileNumberCountry'
                                                )?.value
                                            )?.flagImagePos
                                        " -->
                                    <span
                                        class="sm:mx-0.5 font-medium text-default"
                                        >{{
                                            getCountryByIso(
                                                signUpForm.get(
                                                    'mobileNumberCountry'
                                                )?.value
                                            )?.code
                                        }}</span
                                    >
                                </span>
                            </mat-select-trigger>
                            <ng-container
                                *ngFor="
                                    let country of filteredCountriesMobile;
                                    trackBy: trackByFn
                                "
                            >
                                <mat-option [value]="country.code">
                                    <span class="flex items-center">
                                        <span
                                            class="w-6 h-4 overflow-hidden"
                                            [style.background]="
                                                'url(\'/assets/images/countries/flags.png\') no-repeat 0 0'
                                            "
                                            [style.backgroundSize]="
                                                '24px 3876px'
                                            "
                                        ></span>
                                        <!-- [style.backgroundPosition]="
                                                country.flagImagePos
                                            " -->
                                        <span class="ml-2">{{
                                            country.name
                                        }}</span>
                                        <span class="ml-2 font-medium">{{
                                            country?.code
                                        }}</span>
                                    </span>
                                </mat-option>
                            </ng-container>
                        </mat-select>

                        <mat-error
                            *ngIf="
                                signUpForm
                                    .get('mobileNumber')
                                    ?.hasError('required')
                            "
                        >
                            This field is required.
                        </mat-error>

                        <mat-error
                            *ngIf="
                                !signUpForm
                                    .get('mobileNumber')
                                    ?.hasError('required') &&
                                !signUpForm
                                    .get('mobileNumber')
                                    ?.hasError('minlength') &&
                                !signUpForm
                                    .get('mobileNumber')
                                    ?.hasError('maxlength') &&
                                signUpForm
                                    .get('mobileNumber')
                                    ?.hasError('phoneValidator')
                            "
                        >
                            Invalid mobile number format.
                        </mat-error>
                    </mat-form-field>

                    <!-- Password field -->
                    <mat-form-field class="fuse-mat-no-subscript w-full">
                        <mat-label>Password</mat-label>
                        <input
                            id="password"
                            matInput
                            type="password"
                            [formControlName]="'password'"
                            #passwordField
                        />
                        <button
                            mat-icon-button
                            type="button"
                            (click)="
                                passwordField.type === 'password'
                                    ? (passwordField.type = 'text')
                                    : (passwordField.type = 'password')
                            "
                            matSuffix
                        >
                            <mat-icon
                                class="icon-size-5"
                                *ngIf="passwordField.type === 'password'"
                                [svgIcon]="'heroicons_solid:eye'"
                            ></mat-icon>
                            <mat-icon
                                class="icon-size-5"
                                *ngIf="passwordField.type === 'text'"
                                [svgIcon]="'heroicons_solid:eye-off'"
                            ></mat-icon>
                        </button>

                        <mat-error
                            *ngIf="
                                signUpForm.get('password')?.hasError('required')
                            "
                        >
                            This field is required.
                        </mat-error>
                        <mat-error
                            *ngIf="
                                signUpForm
                                    .get('password')
                                    ?.hasError('minlength')
                            "
                        >
                            Password should be at least 6 characters!
                        </mat-error>

                        <mat-error
                            *ngIf="
                                !signUpForm
                                    .get('password')
                                    ?.hasError('required') &&
                                !signUpForm
                                    .get('password')
                                    ?.hasError('minlength') &&
                                !signUpForm
                                    .get('password')
                                    ?.hasError('maxlength')
                            "
                        >
                            Invalid password format.
                        </mat-error>
                    </mat-form-field>

                    <!-- ToS and PP -->
                    <div class="inline-flex items-end w-full mt-6">
                        <mat-checkbox
                            [color]="'primary'"
                            [formControlName]="'agreements'"
                        >
                            <span>I agree to the</span>
                            <span
                                class="ml-1 text-primary-500 hover:underline cursor-pointer"
                                >Terms of Service
                            </span>
                            <span>and</span>
                            <span
                                class="ml-1 text-primary-500 hover:underline cursor-pointer"
                                >Privacy Policy
                            </span>
                        </mat-checkbox>
                    </div>

                    <!-- Submit button -->
                    <button
                        class="fuse-mat-button-large w-full mt-0.5"
                        mat-flat-button
                        [color]="'primary'"
                        (click)="signUp()"
                        [disabled]="signUpForm.invalid"
                    >
                        <span>Sign up</span>
                        <mat-progress-spinner
                            *ngIf="signUpForm.disabled"
                            [diameter]="24"
                            [mode]="'indeterminate'"
                        >
                        </mat-progress-spinner>
                    </button>
                </form>
            </div>
        </div>
    </div>
</div>
